var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M537.6,226.6c4.1-10.8,6.4-22.4,6.4-34.6,0-53.9-43-96-96-96-19.7,0-38.1,5.1-53.3,16.2-27.7-47.95-79.4-80.2-138.7-80.2-88.4,0-160,71.6-160,160,0,2.7,.07,5.4,.2,8.1C40.17,219.8,0,273.2,0,336,0,415.5,64.47,480,144,480H512c70.7,0,128-57.3,128-128,0-61.9-44-113.6-102.4-125.4Zm-101.8,28.2l-128,128c-10.9,10.9-28.7,10.9-39.6,0l-64-64c-10.9-10.9-10.9-28.7,0-39.6,10.9-10.9,28.7-10.9,39.6,0l44.2,44.2,108.2-108.2c10.9-10.9,28.7-10.9,39.6,0,10.9,10.9,10.9,28.7,0,39.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCheck);
export default __webpack_public_path__ + "static/media/cloud-check.152f84937c000e9d365b2a847591880a.svg";
export { ForwardRef as ReactComponent };